/** @jsxImportSource @emotion/react */
import { Global, css } from '@emotion/react';

/**
 * Global styles for the bucketlist application with soft, femme, nostalgic aesthetics
 * Features dreamy pastels and early 2000s internet cutesy vibes
 */
const globalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&family=Patrick+Hand:wght@400&display=swap');

  :root {
    /* Soft pastel color palette */
    --pink-dream: #ffb3d9;
    --lavender-mist: #d4b3ff;
    --peach-cloud: #ffcab3;
    --mint-whisper: #b3ffd9;
    --vanilla-cream: #fff5e6;
    --rose-quartz: #ffc2d4;
    --sky-blush: #e6f3ff;

    /* Soft gradients */
    --gradient-dreamy: linear-gradient(
      135deg,
      var(--pink-dream) 0%,
      var(--lavender-mist) 50%,
      var(--peach-cloud) 100%
    );
    --gradient-soft: linear-gradient(
      45deg,
      var(--mint-whisper) 0%,
      var(--sky-blush) 100%
    );
    --gradient-clouds: radial-gradient(
      ellipse at top,
      var(--vanilla-cream) 0%,
      transparent 50%
    );
  }

  body {
    margin: 0;
    font-family: 'Comfortaa', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--gradient-clouds), var(--gradient-dreamy);
    background-attachment: fixed;
    min-height: 100vh;
    color: #4a4a4a;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  * {
    box-sizing: border-box;
  }

  /* Cute scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--gradient-soft);
    border-radius: 10px;
    border: 2px solid transparent;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--pink-dream);
  }
`;

const GlobalStyles = () => <Global styles={globalStyles} />;

export default GlobalStyles;
